import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { LocalService, Status, TriggeredEvent, WorkingRangeType, DelivererWrapper, GeneralConfigType, KeyValueSet, FocusInputType, KeyValues10, InteractionType, NumericConfig, KeyValues15 } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { MessageComponent } from '../message/message.component';
import { SmsSettingsComponent } from '../sms-settings/sms-settings.component';

@Component({
  selector: 'app-deliverer-config',
  templateUrl: './deliverer-config.component.html',
  styleUrls: ['./deliverer-config.component.scss']
})
export class DelivererConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["deliverer", "common"]; maxBodyHeight = 0;
  id = ''; userId = ''; ctryCode = ''; isActive = true; isPrivate = false; isAvailableNow = true; wrapper: DelivererWrapper;
  message: string = ''; isRedAlert: boolean = true; workingRangeType: WorkingRangeType = WorkingRangeType.Deliverer;
  mandatoryLanguages = []; notificationTypes: KeyValueSet[]; htmlId: string = '';
  elementIds: any;
  numericConfig: NumericConfig;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private profileManagementService: ProfileManagementService, private router: Router, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      ph_num: 'ph_num_' + this.htmlId,
      email: 'email_' + this.htmlId,
      name: 'service_type_' + this.htmlId,
      first_name: 'service_type_' + this.htmlId + '_m'
    };
    this.numericConfig = { navigateToNextIdIfMaxDigitReached: this.elementIds.email } as NumericConfig;
  }

  ngOnInit(): void {
    this.mandatoryLanguages.push(this.localService.selected.applicationLanguage);
    this.mandatoryLanguages.push(this.languageManagementService.getEnglishLanguageId());
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (this.localService.getLoginAsCountryCode()  == '')
      this.ctryCode = this.localService.selected.countryCode;
    this.numericConfig.maxDigits = this.localService.getContactMaxDigitByCountryCode(this.localService.getLoginAsCountryCode() )
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.NotificationType).subscribe(result => {
      this.notificationTypes = result;
    });
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.profileManagementService.getEmptyDeliverer().subscribe(result => {
        this.wrapper = result;
        this.onSetVariables();
      });
    } else {
      this.profileManagementService.getDeliverer(this.id, this.ctryCode).subscribe(result => {
        this.wrapper = result;
        this.onSetVariables();
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onSetVariables() {
    this.isActive = this.wrapper.source.content.v2 == '1';
    this.isPrivate = this.wrapper.source.content.v3 == '1';
    this.isAvailableNow = this.wrapper.source.content.v4 == '1';
    this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
  }

  onDelete() {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.IsConfirmationType = true;
    modalRef.componentInstance.message = this.localService.languageContent.deliverer.delete_confirmation;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.profileManagementService.toggleDeliver(this.id, 1).subscribe(result => {
          let item = this.localService.loggedMember.businesses.find(x => x.v5 == 'SP');
          if (item) {
            item.key = '';
            item.v1 = '';
            item.v2 = '';
            item.v3 = '';
            item.v4 = '';
            item.v6 = '';
            item.v7 = '';
          }
          this.router.navigate(['/user', this.localService.selected.countryCode, this.localService.selected.user, 1]);
          this.onPopupClose();
        });
      }
    });
  }

  onPopupSave() {
    this.isRedAlert = false;
    this.message = '';
    this.wrapper.source.content.v2 = this.isActive ? "1" : "0";
    this.wrapper.source.content.v3 = this.isPrivate ? "1" : "0";
    this.wrapper.source.content.v4 = this.isAvailableNow ? "1" : "0";
    if (this.doCheck()) {
      this.profileManagementService.saveServiceProvider(this.wrapper.source, this.wrapper.notificationTypes, this.wrapper.languageAddress).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          if (this.id != '') {
            let item = this.localService.loggedMember.businesses.find(x => x.v5 == 'SP');
            if (item) {
              item.key = result.id;
              item.v1 = this.isAvailableNow ? "1" : "0";
              item.v2 = this.isActive ? "1" : "0";
              item.v6 = '0';
              item.v7 = '0';
            } else {
              this.localService.loggedMember.businesses.push({
                key: result.id,
                v1: this.isAvailableNow ? "1" : "0",
                v2: this.isActive ? "1" : "0",
                v5: 'SP',
                v6: '0',
                v7: '0'
              } as KeyValues15);
            }
          }
          this.id = result.id;
          this.onOpenSmsSettings();
          this.activeModal.close({ event: TriggeredEvent.Ok, id: result.id });
        }
        else {
          this.isRedAlert = true;
          switch (result.status) {
            case Status.RangeNotAllowed: {
              this.message = this.localService.languageContent.working_hours.range_not_allowed;
            } break;
          }
        }
      });
    }
  }

  onRangeUpdate(value) {
    this.wrapper.source.range = value;
  }

  onEmptyLanguageContainerAdded(languageContents: any, index) {
    switch (index) {
      case 1: {
        this.wrapper.source.languageContents = languageContents;
      } break;
      case 2: {
        this.wrapper.languageAddress = languageContents;
      } break;
    }
  }

  onAddBusiness() {
    this.router.navigate(['/seller', this.localService.selected.countryCode, 0]);
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onOpenSmsSettings() {
    if (this.wrapper && this.wrapper.notificationTypes.length > 0) {
      const modalRef = this.modalService.open(SmsSettingsComponent, { size: 'lg' });
      modalRef.componentInstance.businessId = this.id;
      modalRef.componentInstance.relationShipType = InteractionType.ServiceProvider;
      modalRef.componentInstance.isShowActive = false;
      modalRef.componentInstance.notificationType = parseInt(this.wrapper.notificationTypes[0]);
    }
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;
    if (!this.wrapper.source.content.v6 || this.wrapper.source.content.v6 == '') {
      message = this.localService.languageContent.deliverer.need_ph_num;
      this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
    } else if (!this.wrapper.source.languageContents || this.wrapper.source.languageContents.filter(x => x.v3.trim() != '').length == 0) {
      message = this.localService.languageContent.deliverer.need_service_type;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }
}
